import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/ramarim/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/ramarim/size`)).data
  },
  async getCategories () {
    return (await request.get(`module/action/marketplace/ramarim/category/retrieve`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/ramarim/brand/retrieve`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/ramarim/index.js